import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { isNilOrEmpty } from '../../core'
import appConfig from 'config'

const EidRoutes = ({ routes }) => {
    const renderWithLayout = ({
        layout: Layout,
        component: Component,
        ...rest
    }) => (
        <Route
            key={rest.name}
            {...rest}
            render={(props) => (
                <Layout {...props}>
                    <Component {...props} />
                </Layout>
            )}
        />
    )

    const renderWithoutLayout = (props) => <Route key={props.name} {...props} />

    return (
        <Switch>
            {routes.map((route) =>
                !isNilOrEmpty(route.layout)
                    ? renderWithLayout(route)
                    : renderWithoutLayout(route),
            )}
            <Redirect from="" to={`${appConfig.APP_SUBPATH}/notfound`} />
        </Switch>
    )
}
export default EidRoutes
